import { render, staticRenderFns } from "./signList.vue?vue&type=template&id=38a03af0&scoped=true&"
import script from "./signList.vue?vue&type=script&lang=js&"
export * from "./signList.vue?vue&type=script&lang=js&"
import style0 from "./signList.vue?vue&type=style&index=0&id=38a03af0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a03af0",
  null
  
)

export default component.exports